module.exports = __webpack_public_path__ + "static/media/admin4b.76bfd592.svg";